import { GET_MONTHLY_SUPPORTS } from "constants/monthlySupports";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_MONTHLY_SUPPORTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
